import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DailyContext {
  summary: string;
  trend_hint?: string;
  pulse?: string;
  generated_at: string;
}

async function fetchContext(): Promise<DailyContext> {
  const { data, error } = await supabase.functions.invoke("fng-context");
  if (error) throw error;
  return data as DailyContext;
}

export function useDailyContext(enabled = false) {
  return useQuery({
    queryKey: ["fng-context"],
    queryFn: fetchContext,
    staleTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false,
    enabled,
  });
}
